import React from "react";
import { LuInfo } from "react-icons/lu";

/** Aviso amarelo dos composers (anexos manuais, permissão do Google). */
export const Notice: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex items-start gap-3 rounded-card border border-warning/30 bg-warning-soft p-3.5 text-caption text-fg">
    <LuInfo size={18} className="mt-px shrink-0 text-warning" aria-hidden />
    <p>{children}</p>
  </div>
);

/** Bloco com rótulo em caixa alta (destinatários, anexos, prévia). */
export const Section: React.FC<{ title: React.ReactNode; children: React.ReactNode }> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    <span className="flex items-center gap-2 text-badge font-bold uppercase tracking-wide text-fg-muted">{title}</span>
    {children}
  </div>
);
